import { render, staticRenderFns } from "./PainelProaes.vue?vue&type=template&id=a77f819c"
import script from "./PainelProaes.vue?vue&type=script&lang=js"
export * from "./PainelProaes.vue?vue&type=script&lang=js"
import style0 from "./PainelProaes.vue?vue&type=style&index=0&id=a77f819c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports